import { connectRegulatory } from 'components/common-form/sidePanel/regulatory/Regulatory.connect';
import { CostsAndCharges } from 'components/quote/costsAndCharges/CostsAndCharges';
import type { CostAndCharge } from 'models/streaming/costsAndCharges';
import { FC } from 'react';

export const Component: FC<{ costsAndChargesResults: CostAndCharge[] }> = ({ costsAndChargesResults }) => {
  return <CostsAndCharges costsAndCharges={costsAndChargesResults} />;
};
export const CostsAndChargesField = connectRegulatory(Component);
CostsAndChargesField.displayName = 'CostsAndChargesField';
